import { BdsText } from "@buildertrend/components";

import { DateDisplayDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate";

import "./UserInfoViewDisplay.less";

export interface IUserInfoViewDisplayProps {
    addedByUserName?: string | null;
    addedByUserDate?: Date | null;
    updatedByUserName?: string | null;
    updatedByUserDate?: Date | null;
}

const UserInfoViewDisplay = ({
    addedByUserName,
    addedByUserDate,
    updatedByUserName,
    updatedByUserDate,
}: IUserInfoViewDisplayProps) => {
    const boldName = (name: string) => <span className="name"> {name}</span>;

    return (
        <div className="flex flex-col userInfoViewDisplay">
            {updatedByUserName && updatedByUserDate && (
                <>
                    <div className="flex flex-row">
                        <BdsText
                            className="userAction"
                            size="normal-sm"
                            text={<span>Updated by {boldName(updatedByUserName)}</span>}
                        />
                    </div>
                    <div className="flex flex-row updatedBy">
                        <BdsText
                            size="normal-sm"
                            text={
                                <DateDisplayDate
                                    value={updatedByUserDate}
                                    showTime
                                    showDayOfWeek
                                    data-testid={"updated-by-user-date"}
                                />
                            }
                        />
                    </div>
                </>
            )}

            {addedByUserName && addedByUserDate && (
                <>
                    <div className="flex flex-row">
                        <BdsText
                            className="userAction"
                            size="normal-sm"
                            text={<span>Published by {boldName(addedByUserName)}</span>}
                        />
                    </div>
                    <div className="flex flex-row">
                        <BdsText
                            size="normal-sm"
                            text={
                                <DateDisplayDate
                                    value={addedByUserDate}
                                    showTime
                                    showDayOfWeek
                                    data-testid={"added-by-user-date"}
                                />
                            }
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default UserInfoViewDisplay;
